import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import './CallToAction.scss';

const CallToAction = ({
  label,
  icon,
  action,
}) => (
  <button
    type="button"
    className="call-to-action-button"
    onClick={() => {
      if (action) {
        action();
      }
    }}
  >
    {icon && (
      <Icon icon={icon} color="#fff" size="1x" />
    )}
    {label && (
      <span>{label}</span>
    )}
  </button>
);

CallToAction.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  action: PropTypes.func,
};

CallToAction.defaultProps = {
  label: undefined,
  icon: undefined,
  action: undefined,
};

export default CallToAction;
